import { render } from "./SushiMenu.vue?vue&type=template&id=30fef347"
import script from "./SushiMenu.vue?vue&type=script&lang=js"
export * from "./SushiMenu.vue?vue&type=script&lang=js"

import "./SushiMenu.vue?vue&type=style&index=0&id=30fef347&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__